<template>
  <div>
    <ContentLoader
      :height="48"
      :width="720"
      :speed="1"
      preserve-aspect-ratio="none"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="bar-code-loader"
    >
      <rect x="0" y="0" rx="4" ry="4" width="720" height="48" />
    </ContentLoader>
  </div>
</template>

<style lang="scss" scoped>
.bar-code-loader {
  height: 48px;
  max-width: 100%;
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>
